<c-container class="mt-5">
  @if (chosenGamesActiveDraw) {
    <div class="draw-banner">
      <div>
        <div class="banner-label">Next Draw</div>
        <div class="banner-value" data-testid="current-draw-next-draw">
          {{ nextDraw$ | async }}
        </div>
      </div>
      <div class="text-end">
        <div class="banner-label">Current Pot</div>
        <div class="banner-value" data-testid="current-draw-current-pot">{{ chosenGamesActiveDraw.PotTotal | formatCurrency }}</div>
      </div>
    </div>

    <h2 data-testid="active-game-title">Current {{ activeGame?.Name }} Draw
      <button
        mat-mini-fab
        data-testid="open-manage-game-options-menu-button"
        *userHasCausableAdminAccess
        class="float-right primary-background-color"
        [matMenuTriggerFor]="menu">
        <mat-icon matTooltipPosition="right"
                  matTooltip="open game settings"
        >more_vertical
        </mat-icon>
      </button>
    </h2>
    @if (chosenGamesActiveDraw.Id) {
      <div class="flex-row-wrap gap-normal justify-space-between">
        <div class="full-width" *hasPermission="permissionTypes.ViewGameSummaryReport">
          <app-display-active-game-instance
            [setSelectedGameInstance]="chosenGamesActiveDraw"></app-display-active-game-instance>
        </div>
      </div>
    }

  } @else {

    <div class="flex-row-wrap gap-normal" data-testid="no-active-games-div">
      Hey looks like there is no currently active draw. Please wait while the new game is being set up.
    </div>
  }
</c-container>


<mat-menu #menu="matMenu">
  <button mat-menu-item
          (click)="openEndGameInstance()"
          data-testid="end-game-instance-button">
    <mat-icon class="dark-grey menu-icon">edit</mat-icon>
    <span class="dark-grey menu-text">Update Draw date and time</span>
  </button>
</mat-menu>
